module.exports = __webpack_public_path__ + "img/flower.12430fab.svg";